<template>
  <div class="relative overflow-x-hidden flex-1 px-6 py-6 flex">
    <div class="flex-1">
      <!-- Title Bar -->
      <div
        class="
          flex
          items-center
          justify-between
          flex-wrap
          gap-4
          pb-4
          border-b border-gray-300
        "
      >
        <div class="flex items-center space-x-6">
          <h1 class="text-2xl font-semibold text-gray-800">ตั้งค่า Device</h1>
          <button
            @click="handleAddDevice"
            type="button"
            :disabled="formAction === 'edit'"
            :class="{ 'cursor-not-allowed': formAction === 'edit' }"
            class="
              inline-flex
              items-center
              px-4
              py-2
              border border-transparent
              rounded-md
              shadow-sm
              text-base
              font-semibold
              tracking-wider
              text-white
              bg-cyan-600
              hover:bg-cyan-700
              focus:outline-none
              focus:ring-2
              focus:ring-offset-2
              focus:ring-cyan-500
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="-ml-1 mr-2 h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                clip-rule="evenodd"
              />
            </svg>
            เพิ่ม Device
          </button>

          <button
            @click="copyDevice"
            type="button"
            class="
              inline-flex
              items-center
              px-4
              py-2
              border border-gray-300
              rounded-md
              shadow-sm
              text-base
              font-semibold
              tracking-wider
              text-gray-700
              bg-white
              hover:bg-gray-50
              focus:outline-none
              focus:ring-2
              focus:ring-offset-2
              focus:ring-cyan-500
            "
          >
            Copy Device
          </button>
        </div>

        <div class="flex items-center space-x-3">
          <SearchWidgetResultsList v-model="search" @input="handleSearch" />

          <AppAutoComplete
            v-model="filterHardwareStatus"
            :isLoading="loading"
            :isSearch="false"
            :options="hardwareStatus"
            label="เลือกตามสถานะ"
            item-text-key="title_th"
            item-value-key="hardware_status_code"
            class="w-60 flex-shrink-0"
            @input="handleFilterHardwareStatus"
          />

          <AppAutoComplete
            v-model="filterCustomer"
            :isLoading="loading"
            :isSearch="true"
            :options="customers"
            label="เลือกตามบริษัท"
            item-text-key="title_th"
            item-value-key="company_uuid"
            class="w-72 flex-shrink-0"
            @input="handleFilterCustomer"
          />
        </div>
      </div>
      <!-- end title bar -->

      <!-- table -->
      <div class="mt-4">
        <AppDataTable
          :isCheckbox="false"
          :options="options"
          :headers="[
            {
              text: 'Device S/N',
              class: 'text-left w-40',
              value: 'hardware_serial_number',
            },
            {
              text: 'Device Model',
              class: 'text-left w-44',
              value: 'hardware_model.title',
            },
            {
              text: 'สถานะ Device',
              class: 'text-left w-44',
              value: 'hardware_status.title_th',
            },
            // {
            //   text: 'ประเภท Device',
            //   class: 'text-left w-44',
            //   value: 'is_access_control',
            //   sortable: false,
            // },
            {
              text: 'ลูกค้า',
              class: 'text-left',
              value: 'company.title_th',
              sortable: false,
            },
            {
              text: 'โน๊ต',
              class: 'text-left',
              value: 'note',
              sortable: false,
            },
          ]"
          :items="hardwares"
          :loading="loading"
          @sort="sort"
          :isNext="true"
          :rowClassFunction="rowClassFunction"
          @rowClick="onRowClick"
        >
          <template v-slot:is_access_control="{ item }">
            {{ item.is_access_control ? 'Access Control' : 'Time Attendance' }}
          </template>
        </AppDataTable>
      </div>
      <!-- end table -->

      <!-- pagination -->
      <div class="py-4 flex items-center justify-start">
        <AppPagination
          :options="options"
          :startNumberItem="startNumberItem"
          :endNumberItem="endNumberItem"
          :totalItems="totalHardwares"
          :isPrevPage="isPrevPage"
          :isNextPage="isNextPage"
          @decreasePage="() => options.page--"
          @increasePage="() => options.page++"
          @itemsPerPageChange="() => (options.page = 1)"
        />
      </div>
      <!-- end pagination -->
    </div>

    <transition
      enter-active-class="transition ease-in-out duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition ease-in-out duration-300"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        @click="onCloseForm"
        v-if="isOpen && formAction === 'add'"
        class="fixed inset-0 bg-gray-900 bg-opacity-30"
      />
    </transition>

    <!-- form -->
    <AppSlideOverPanel :isOpen="isOpen">
      <FormHardware
        :formAction="formAction"
        :currentHardware="currentHardware"
        :hardware="hardware"
        @onClose="onCloseForm"
        @onAdd="fetchHardwaresApi"
        @onSave="fetchHardwaresApi"
        @onCancel="onCancelForm"
        @isDataChange="(value) => (isDataFormChange = value)"
        @updateHardware="handleUpdateHardware"
        @onHardwareCompanyChange="handleHardwareCompanyChange"
        @onDelete="onDelete"
      />
    </AppSlideOverPanel>
    <!-- end form -->

    <!-- confirm delete -->
    <ModalDeleteHardware
      :show="isDelete"
      :loading="deleteLoading"
      :item="deleteItem"
      :errors="deleteErrors"
      @clear="deleteErrors = []"
      @cancel="onCancelDeleteHardware"
      @submit="onSubmitDeleteHardware"
    />
    <!-- end confirm delete -->

    <!-- confirm leave page -->
    <AppConfirmLeavePageModal
      :show="isConfirmLeavePageShow"
      :type="isConfirmLeavePageType"
      :next="isConfirmLeavePageNextFunction"
      @cancel="onCancelConfirmLeavePage"
      @submit="onSubmitConfirmLeavePage"
    >
      <template v-if="isConfirmLeavePageType === 'form'" v-slot:title
        >ต้องการปิดใช่ไหม</template
      >
      <template v-if="isConfirmLeavePageType === 'form'" v-slot:message
        >คุณยังไม่ได้บันทึกข้อมูลของคุณ
        คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล ?</template
      >
    </AppConfirmLeavePageModal>
    <!-- end confirm leave page -->

    <!-- copy device modal -->
    <CopyDeviceModal
      :isOpen="isCopyDeviceModalOpen"
      @onClose="isCopyDeviceModalOpen = false"
    />
    <!-- end copy device modal -->
  </div>
</template>

<script>
import _ from 'lodash'

import { mapActions } from 'vuex'

import AppAutoComplete from '@/components/AppAutoComplete'
import AppConfirmLeavePageModal from '@/components/AppConfirmLeavePageModal'
import AppDataTable from '@/components/AppDataTable'
import AppPagination from '@/components/AppPagination'
import AppSlideOverPanel from '@/components/AppSlideOverPanel'
import CopyDeviceModal from '@/components/CopyDeviceModal'
import FormHardware from '@/components/FormHardware'
import ModalDeleteHardware from '@/components/ModalDeleteHardware'
import SearchWidgetResultsList from '@/components/SearchWidgetResultsList'

export default {
  name: 'HardwareList',

  components: {
    SearchWidgetResultsList,
    AppAutoComplete,
    AppDataTable,
    AppPagination,
    AppSlideOverPanel,
    CopyDeviceModal,
    FormHardware,
    ModalDeleteHardware,
    AppConfirmLeavePageModal,
  },

  data() {
    return {
      loading: false,
      search: '',
      options: {
        sortBy: 'hardware_serial_number',
        sortDesc: false,
        itemsPerPage: 10,
        page: 1,
      },
      filterHardwareStatus: null,
      filterCustomer: null,
      currentHardware: {},
      hardware: {},
      formAction: '',
      isDelete: false,
      deleteLoading: false,
      deleteItem: {},
      isOpen: false,
      timeout: null,
      isDataFormChange: false,
      isConfirmLeavePageShow: false,
      isConfirmLeavePageType: '',
      isConfirmLeavePageNextFunction: null,
      deleteErrors: [],
      isCopyDeviceModalOpen: false,
      hardwares: [],
      totalHardwares: 0,
    }
  },

  watch: {
    options: {
      handler() {
        this.fetchHardwaresApi()
      },
      deep: true,
    },
  },

  computed: {
    hardwareStatus() {
      return this.$store.state.hardware.hardwareStatus
    },

    customers() {
      return this.$store.state.customer.customers
    },

    startNumberItem() {
      return (this.options.page - 1) * this.options.itemsPerPage + 1
    },

    endNumberItem() {
      const sum = this.options.page * this.options.itemsPerPage
      if (sum < this.totalHardwares) return sum

      return this.totalHardwares
    },

    isPrevPage() {
      if (this.options.page === 1) return true

      return false
    },

    isNextPage() {
      return (
        this.options.page ===
        Math.ceil(this.totalHardwares / this.options.itemsPerPage)
      )
    },
  },

  created() {
    this.$store.commit('setMenusCustomerActive', false)
    this.$store.commit('setBreadcrumbs', [
      { text: 'ตั้งค่า Device', routeName: 'HardwareList' },
    ])

    this.fetchDataFromApi()
    this.fetchHardwaresApi()
  },

  methods: {
    ...mapActions({
      fetchHardwares: 'hardware/fetchHardwares',
      fetchHardwareStatus: 'hardware/fetchHardwareStatus',
      fetchHardwareModels: 'hardware/fetchHardwareModels',
      fetchCustomers: 'customer/fetchCustomers',
    }),

    copyDevice() {
      this.isCopyDeviceModalOpen = true
    },

    handleSearch() {
      this.loading = true
      this.fetchHardwaresBySearch()
    },

    fetchHardwaresBySearch: _.debounce(function () {
      this.options.page = 1
      this.fetchHardwaresApi()
    }, 1000),

    handleFilterHardwareStatus() {
      this.options.page = 1
      this.fetchHardwaresApi()
    },

    handleFilterCustomer() {
      this.options.page = 1
      this.fetchHardwaresApi()
    },

    async fetchHardwaresApi() {
      try {
        let sort

        if (this.options.sortBy === 'hardware_model.title') {
          sort = `title_hardware_model:${
            this.options.sortDesc ? 'desc' : 'asc'
          }`
        }
        if (this.options.sortBy === 'hardware_serial_number') {
          sort = `hardware_serial_number:${
            this.options.sortDesc ? 'desc' : 'asc'
          }`
        }
        if (this.options.sortBy === 'hardware_status.title_th') {
          sort = `title_th_hardware_status:${
            this.options.sortDesc ? 'desc' : 'asc'
          }`
        }

        this.loading = true

        const result = await this.fetchHardwares({
          params: {
            search: this.search ? this.search : undefined,
            hardware_status_code: this.filterHardwareStatus
              ? this.filterHardwareStatus.hardware_status_code
              : undefined,
            company_uuid: this.filterCustomer
              ? this.filterCustomer.company_uuid
              : undefined,
            sort,
            is_manageable: true,
            limit: this.options.itemsPerPage,
            offset: (this.options.page - 1) * this.options.itemsPerPage,
          },
        })

        this.hardwares = result.hardwares
        this.totalHardwares = result.totalHardwares

        return result
      } catch (error) {
        console.log(error.response)
      } finally {
        this.loading = false
      }
    },

    handleHardwareCompanyChange() {
      this.hardware.hardware_status = null
    },

    handleUpdateHardware(hardware) {
      this.hardware = { ...hardware }
    },

    onCancelConfirmLeavePage() {
      this.isConfirmLeavePageShow = false
    },

    onSubmitConfirmLeavePage(obj) {
      this.isDataFormChange = false
      this.formAction = ''
      if (obj.type === 'form') {
        this.isConfirmLeavePageShow = false
        this.isOpen = false
        this.currentHardware = {}
        this.hardware = {}
        return
      }
      if (obj.type === 'page') {
        this.isConfirmLeavePageShow = false
        this.isOpen = false
        this.currentHardware = {}
        this.hardware = {}
        this.timeout = setTimeout(() => {
          obj.next()
        }, 500)
        return
      }
    },

    onCancelForm() {
      this.isDataFormChange = false
      this.isOpen = false
      this.formAction = ''
      this.currentHardware = {}
      this.hardware = {}
    },

    onCloseForm() {
      if (this.isDataFormChange) {
        this.isConfirmLeavePageShow = true
        this.isConfirmLeavePageType = 'form'
      } else {
        this.isOpen = false
        this.formAction = ''
        this.currentHardware = {}
        this.hardware = {}
      }
    },

    rowClassFunction(item) {
      if (this.hardware.hardware_uuid === item.hardware_uuid) {
        return 'cursor-pointer bg-gray-200'
      }
      return 'cursor-pointer hover:bg-gray-100'
    },

    handleAddDevice() {
      this.formAction = 'add'
      this.isOpen = true
      this.currentHardware = {
        hardware_serial_number: '',
        access_control: {
          text: 'Time Attendance',
          is_access_control: false,
        },
      }
      this.hardware = {
        hardware_serial_number: '',
        access_control: {
          text: 'Time Attendance',
          is_access_control: false,
        },
      }
    },

    onDelete(item) {
      this.isDelete = true
      this.isOpen = false
      this.deleteItem = { ...item }
    },

    onCancelDeleteHardware() {
      this.isDelete = false
      this.isOpen = true
      this.deleteErrors = []
    },

    async onSubmitDeleteHardware(item) {
      try {
        this.deleteLoading = true

        await this.$store.dispatch(
          'hardware/deleteHardware',
          item.hardware_uuid
        )

        this.deleteLoading = false
        this.isDelete = false
        this.deleteErrors = []

        const notification = {
          type: 'success',
          message: 'Your hardware has been deleted!',
        }
        this.$store.dispatch('notification/add', notification)

        this.formAction = ''
        this.fetchHardwaresApi()
      } catch (error) {
        this.deleteLoading = false

        if (error.response && error.response.data) {
          this.deleteErrors.push(
            error.response.data.message || 'Something went wrong.'
          )
          return
        }

        console.log(error.response)
      }
    },

    onRowClick(item) {
      if (this.hardware.hardware_uuid === item.hardware_uuid) {
        this.onCloseForm()
      } else {
        this.formAction = 'edit'
        this.isOpen = true
        this.currentHardware = {
          ...item,
          access_control: {
            text:
              item.is_access_control === true
                ? 'Access Control'
                : 'Time Attendance',
            is_access_control: item.is_access_control,
          },
        }
        this.hardware = {
          ...item,
          access_control: {
            text:
              item.is_access_control === true
                ? 'Access Control'
                : 'Time Attendance',
            is_access_control: item.is_access_control,
          },
        }
      }
    },

    async fetchDataFromApi() {
      try {
        this.loading = true

        await Promise.all([
          this.fetchHardwareStatus(),
          this.fetchHardwareModels({ params: { is_manageable: true } }),
          this.fetchCustomers(),
        ])
      } catch (error) {
        console.log(error.response)
      } finally {
        this.loading = false
      }
    },

    sort(value) {
      if (this.options.sortBy === value) {
        this.options.sortDesc = !this.options.sortDesc
        this.options.page = 1
      } else {
        this.options.sortBy = value
        this.options.sortDesc = false
        this.options.page = 1
      }
    },
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDataFormChange) {
      this.isConfirmLeavePageShow = true
      this.isConfirmLeavePageType = 'page'
      this.isConfirmLeavePageNextFunction = next
      return
    }
    if (this.isOpen) {
      this.isOpen = false
      this.timeout = setTimeout(() => {
        next()
      }, 500)
      return
    }

    next()
  },
}
</script>
